import React from 'react'
import { I18n } from '@front/volcanion'

import { Box, Typography, Grid } from '@mui/material'
import { ModelAutocompleteField, TextField } from '@front/squirtle'

const Title = props => <Grid size={12}><Typography variant={'h5'}> {I18n.t('equipment.search')}</Typography> </Grid>

const Row1 = props =>
  <Grid container spacing={1} size={12}>
    <Grid size="grow">
      <ModelAutocompleteField
        name={'equipment_id'}
        label={I18n.t('name.label', { count: 1 })}
        model_name={'equipment'}
        searchMode={'search'}
        autocompleteMutator={q => ({
          name_trkey: { fr: { contains: q } }
        })}
        labelKeys={['name_trkey.fr']}
        config={{
          populate: ['name_trkey']
        }}
        loadOnFocus={false}
        clearOnEmpty
      />
    </Grid>
    <Grid size="grow"><TextField name={'price'} label={I18n.t('price.label')} /></Grid>
    <Grid size={2}><TextField name={'currency'} label={I18n.t('fiat.label', { count: 1 })} /></Grid>
  </Grid>

const SearchForm = props =>
  <Box sx={{ p: 1, boxShadow: 6, borderRadius: 1 }}>
    <Grid container rowSpacing={3}>
      <Title />
      <Row1 {...props} />
    </Grid>
  </Box>

export default React.memo(SearchForm)
